/**
 * HP Stats — count-up when section enters viewport.
 *
 * Target: [data-count-up="31"] (target number)
 * Optional: data-count-duration (default 2000), data-count-delay (default 200)
 */
(function () {
  'use strict';

  var ROOT_SELECTOR = '.hp-stats';
  var TARGET_SELECTOR = '[data-count-up]';
  var DEFAULT_DURATION = 2000;
  var DEFAULT_DELAY = 200;

  function easeOutQuad(t) {
    return t * (2 - t);
  }

  function animateCount(element, start, end, duration) {
    var startTimestamp = null;

    function step(timestamp) {
      if (!startTimestamp) startTimestamp = timestamp;
      var progress = Math.min((timestamp - startTimestamp) / duration, 1);
      var current = start + easeOutQuad(progress) * (end - start);
      element.textContent = String(Math.floor(current));
      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        element.textContent = String(end);
      }
    }

    window.requestAnimationFrame(step);
  }

  function runCount(target) {
    if (target.classList.contains('counted')) return;

    var value = parseInt(target.getAttribute('data-count-up'), 10);
    if (isNaN(value)) return;

    var duration = parseInt(target.getAttribute('data-count-duration'), 10);
    if (isNaN(duration) || duration <= 0) duration = DEFAULT_DURATION;

    var delay = parseInt(target.getAttribute('data-count-delay'), 10);
    if (isNaN(delay) || delay < 0) delay = DEFAULT_DELAY;

    var countEl = target.querySelector('[data-count-up-value]') || target;
    target.classList.add('visible', 'counted');

    window.setTimeout(function () {
      animateCount(countEl, 0, value, duration);
    }, delay);
  }

  function runAllCounts(root) {
    var targets = root.querySelectorAll(TARGET_SELECTOR);
    for (var i = 0; i < targets.length; i++) {
      runCount(targets[i]);
    }
  }

  function initRoot(root) {
    if (!root || root.getAttribute('data-hp-stats-count-init') === 'true') return;
    root.setAttribute('data-hp-stats-count-init', 'true');

    var targets = root.querySelectorAll(TARGET_SELECTOR);
    if (!targets.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          runAllCounts(root);
          observer.disconnect();
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    observer.observe(root);
  }

  function initAll(scope) {
    var roots;
    if (scope && scope.querySelectorAll) {
      if (scope.matches && scope.matches(ROOT_SELECTOR)) {
        roots = [scope];
      } else {
        roots = scope.querySelectorAll(ROOT_SELECTOR);
      }
    } else {
      roots = document.querySelectorAll(ROOT_SELECTOR);
    }

    for (var i = 0; i < roots.length; i++) {
      initRoot(roots[i]);
    }
  }

  function onReady() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
